import { ServiceBase } from '../../../core/services/ServiceBase'
import ConnectMapProxy from './proxy'

class ConnectMapService extends ServiceBase {
  getSearchCompany(params) {
    return this.getData(() => ConnectMapProxy.getSearchCompany(params))
  }

  getSearchPerson(params) {
    return this.getData(() => ConnectMapProxy.getSearchPerson(params))
  }

  createConnectionMapLogs(params) {
    return this.getData(() => ConnectMapProxy.createConnectionMapLogs(params))
  }

  updateConnectionMapLogs(params) {
    return this.getData(() => ConnectMapProxy.updateConnectionMapLogs(params))
  }

  uploadFileConnectMap(params) {
    return this.getData(() => ConnectMapProxy.uploadFileConnectMap(params))
  }

  upgradeConnectMap(params) {
    return this.getData(() => ConnectMapProxy.upgradeConnectMap(params))
  }

  getPersonDetail(params) {
    return this.getData(() => ConnectMapProxy.getPersonDetail(params))
  }

  getCompanyDetail(params) {
    return this.getData(() => ConnectMapProxy.getCompanyDetail(params))
  }
}

export default new ConnectMapService()
